/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 8/7/2019
 */

function CustomMetadataFieldComponent(
    this: JS5Object,
    _: JS5Object
) {

    //======================//
    // Field Type Constants //
    //======================//

    let defaultFormData: JS5Object = {
        textinput: {
            columnClass: 'pad-sm-right col-sm-',
            componentClass: 'prism-text-input',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datetimefield: {
            columnClass: 'col-sm-7 date-time padding-bottom-xsm no-padding',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datetimefieldenhanced: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datefieldenhanced: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datefield: {
            columnClass: 'col-sm-3 pad-sm-right',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        textarea: {
            columnClass: 'pad-sm-right col-sm-',
            componentClass: 'form-control prism-text-input',
            requiredClass: 'required-text-area-3',
            warningClass: 'error-warning-text-area-3'
        },
        timeinput: {
            columnClass: 'col-sm-2 top-margin pad-sm-right auto-width time-component',
            requiredClass: 'required-time-picker',
            warningClass: 'spacer-top-sm'
        },
        timecodeinput: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm',
            attributes: {
                'root-class': 'col-sm-2'
            }
        },
        checkbox: {
            columnClass: 'col-sm-1 spacer-top-sm pad-sm-right auto-width',
            componentClass: 'timepicker col-sm-3',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-sm'
        },
        dropdownlist: {
            columnClass: 'col-md-2 metadata-control-col',
            warningClass: 'metadata-icons-col',
            requiredClass: 'required-text-input',
        },
        checkboxlist: {
            columnClass: 'col-sm-2 checkbox-list-md',
            requiredClass: 'required-checkbox-list',
            warningClass: 'error-warning-checkbox-list'
        },
        list: {
            columnClass: 'col-sm-2 checkbox-list-md',
            requiredClass: 'required-list',
            warningClass: 'error-warning-list'
        },
        textlistinput: {
            columnClass: 'col-sm-4 text-list-input',
            requiredClass: 'required-list',
            warningClass: 'error-warning-list'
        }
    };


    //====================//
    // Style Modification //
    //====================//

    const calculateColumnSize = (percentage: string) => {
        return Math.round((11 - this.labelColSize) * (parseInt(percentage) / 100));
    };

    this.getColumnClassSize = () => {
        if (this.ignorePreferredWidth) {
            // Leave column for override, warning/error, required asterisk
            return 9;
        }
        if (this.componentDef.preferredWidth) {
            return calculateColumnSize(this.componentDef.preferredWidth);
        }
        return (5 - this.labelColSize);
    };

    const applyOverriddenStyles = (formData: JS5Object, overrides: JS5Object) => {
        angular.forEach(overrides, (override: any, overrideProperty: string) => {
            if (overrideProperty === 'attributes') {
                angular.forEach(override, (attrOverride: any, attrProperty: string) => {
                    formData.attributes[attrProperty] = attrOverride;
                });
            } else {
                formData[overrideProperty] = override;
            }
        });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$doCheck = () => {
        this.showOverrideCheckbox = (
            this.componentDef.liveUpdate
            && ((this.revision < 2) || this.componentDef.alwaysLive)
        );
        this.disabled = this.showOverrideCheckbox && !this.componentDef.instanceData.valueOverridden;
    };

    this.$onInit = () => {
        this.fieldType = this.componentDef.uiControlHint.toLowerCase();
        this.inputId = this.idPrefix + this.componentDef.name;
        this.labelColSize = this.labelColSize || 2;
        _.forEach(defaultFormData, (defaultData: JS5Object) => {
            defaultData.labelClass = 'control-label col-sm-' + this.labelColSize;
        });

        let formData = _.assign({}, defaultFormData[this.fieldType]);
        applyOverriddenStyles(formData, _.get(this, `componentStyleOverrides.${this.fieldType}`));
        applyOverriddenStyles(formData, _.get(this, `componentStyleOverrides.${this.componentDef.name}`));
        this.formData = formData;
        this.$doCheck();
    };

}

angular.module('prism-ui.components').component('customMetadataField', {
    templateUrl: 'components/form/customMetadata/customMetadataField/custom-metadata-field-template.html',
    controller: CustomMetadataFieldComponent,
    bindings: {
        componentDef: '=',
        componentStyleOverrides: '<',
        disableComponents: '<',
        idPrefix: '<',
        ignorePreferredWidth: '<',
        labelColSize: '<',
        onUpdate: '&',
        revision: '<', // partner package revision
    }
});



